/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateNeighborhoodsVisibilityPauseStatus} from '../api'

export const useMutationUpdateNeighborhoodsVisibilityPauseStatus = createReactQueryMutationHook('updateNeighborhoodsVisibilityPauseStatus', updateNeighborhoodsVisibilityPauseStatus)
